// extracted by mini-css-extract-plugin
export default {"root_image_inner":"bannerForm_root_image_inner__6UE67"};